import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { translate } from 'react-i18next';

import Form from './Form';
import WrapperSecondary from '../../common/WrapperSecondary';
import Render from '../../common/Render';
import * as API from '../../core/api';
import { requestDataIfNeeded } from '../duck';
import { receiveLoginToken } from '../../auth/duck';
import { catchFormErrors } from '../../utils/form-errors';

class Screen extends React.Component {
  componentDidMount() {
    const { inviteId } = this.props.match.params;

    this.props.requestInviteDataIfNeeded(inviteId);
  }

  handleSubmit = (formValues) => {
    const { inviteId } = this.props.match.params;
    const { password } = formValues;

    return API.post(`invites/${inviteId}/accept`, { password })
      .then((data) => {
        // Authenticate the user immediately,
        // since the successful accepting request returns a token,
        // same like the /login one.
        this.props.receiveLoginToken(data);

        this.props.history.push('/onboarding/add-projects');
      })
      .catch(catchFormErrors);
  };

  renderAfterLoading = () => {
    const { t, email, invite } = this.props;

    return (
      <WrapperSecondary
        title={t('invite.accept.title')}
        subtitle={t('invite.accept.subtitle', { name: invite.userMeta.name })}
      >
        <Form onSubmit={this.handleSubmit} initialValues={{ email }} />
      </WrapperSecondary>
    );
  };

  render() {
    const { t, error, isLoading, isAlreadyAccepted } = this.props;

    if (isAlreadyAccepted) {
      return (
        <div className="o-wrapper u-text-center">
          <p className="c-alert c-alert--danger u-margin-top">
            {t('invite.accept.alreadyAcceptedError')}
            <br />
            <br />
            <Link to="/login" style={{ textDecoration: 'underline' }}>
              {t('general.login')}
            </Link>
          </p>
        </div>
      );
    }

    return (
      <Render
        isLoading={isLoading}
        error={error}
        render={this.renderAfterLoading}
      />
    );
  }
}

const mapDispatchToProps = {
  requestInviteDataIfNeeded: requestDataIfNeeded,
  receiveLoginToken,
};
const mapStateToProps = ({ invite }) => ({
  error: invite.error,
  isLoading: invite.isLoading,
  email: invite.data && invite.data.email,
  invite: invite.data,
  isAlreadyAccepted: invite.data && invite.data.status === 'ACCEPTED',
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(translate()(Screen))
);



// WEBPACK FOOTER //
// ./src/invite/accept/Screen.js